import { API_BASE_URL } from './config';
import { throwApiError } from './errors';
import type { AppHtmlPolicy, AppManifest } from './apps';

const BASE = `${API_BASE_URL}/api/v1/public/apps`;
const TOKEN_HEADER = 'X-App-Link-Token';

export interface PublicAppView {
  readonly manifest: AppManifest;
  /** Null when the creator has no display name; never their email. */
  readonly creatorName: string | null;
  readonly htmlPolicy: AppHtmlPolicy;
}

// Plain fetch on purpose: the visitor has no session, and the shared client
// would attach a stale token or send a refused request to the login page.
const fetchPublic = async (path: string, token: string): Promise<Response> => {
  const res = await fetch(`${BASE}${path}`, {
    headers: { [TOKEN_HEADER]: token },
    credentials: 'omit',
    referrerPolicy: 'no-referrer',
  });
  if (!res.ok) {
    const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
    throwApiError(res, data, "This app isn't available.");
  }
  return res;
};

export async function getPublicApp(token: string): Promise<PublicAppView> {
  return (await fetchPublic('/view', token)).json() as Promise<PublicAppView>;
}

export async function getPublicAppPage(token: string): Promise<string> {
  return (await fetchPublic('/page', token)).text();
}
